module.exports = (__parcel__import__("2IUUH")).then(() => parcelRequire('g36Vt'));